import { render, staticRenderFns } from "./MediaGalleryItem.vue?vue&type=template&id=79878c4c&scoped=true&"
import script from "./MediaGalleryItem.vue?vue&type=script&lang=ts&"
export * from "./MediaGalleryItem.vue?vue&type=script&lang=ts&"
import style0 from "./MediaGalleryItem.vue?vue&type=style&index=0&id=79878c4c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79878c4c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VHover,VIcon,VProgressLinear})
